/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { processNum } from '../../utils/num';
import { isEditable } from '../../utils/roles';

export const NumLittleGauge = props => {
  const {
    num,
    numId,
    itemId,
    value,
    updateField,
    orientation = 'horizontal',
    canEdit = true,
  } = props;

  const [editValue, setEditValue] = useState(false);
  const isVertical = orientation === 'vertical';
  const canInteract = isEditable() && canEdit;

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);

  const setMod = newValue => {
    updateField(newValue, 'mod');
  };

  const updateMod = delta => {
    setMod(num.mod + delta);
  };

  const totalValue = processNum(
    { num, numId, useMod: false, useCon: true },
    item,
    items
  );

  const ratio =
    typeof totalValue === 'number' && totalValue !== 0
      ? Math.min(Math.max(value / totalValue, 0), 1)
      : 0;
  const progressPercent = ratio * 100;

  const renderHorizontalGauge = () => (
    <div className='relative flex flex-col items-center justify-center w-full h-full px-05 '>
      <div className='flex w-full relative'>
        <div
          className={`${
            value < totalValue ? 'rounded-tl rounded-bl' : 'rounded'
          } bg-primary py-01 transition-all`}
          style={{
            transition: '300ms',
            width: `${progressPercent}%`,
          }}
        ></div>
        <div
          className={`${
            value < totalValue ? 'rounded-tr rounded-br' : 'rounded'
          } flex-1 bg-contrast bg-opacity-10 py-01 transition-all`}
        ></div>
        <div
          className={`absolute flex right-0 left-0 -top-03  ${
            !editValue ? 'parent-hover' : ''
          }`}
        >
          {canInteract && (
            <div
              className={`cursor-pointer show-on-hover mt-0 ml-05 ${
                editValue ? 'hidden' : ''
              }`}
              onClick={() => updateMod(-1)}
              onContextMenu={e => {
                e.preventDefault();
                setMod(-totalValue);
              }}
            >
              <FaMinus />
            </div>
          )}

          <div
            onClick={() => canInteract && setEditValue(true)}
            className='flex-1 mt-0 parent-hover'
          >
            <div className='text-center text-xs show-on-hover'>
              {value} / {totalValue}
            </div>
          </div>

          {canInteract && (
            <div
              className={`cursor-pointer show-on-hover mt-0 mr-05 ${
                editValue ? 'hidden' : ''
              }`}
              onClick={() => updateMod(1)}
              onContextMenu={e => {
                e.preventDefault();
                setMod(0);
              }}
            >
              <FaPlus />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderVerticalGauge = () => (
    <div className='relative flex flex-col items-center justify-center w-full h-full px-05'>
      <div className='flex flex-col items-center w-full h-full gap-02'>
        {canInteract && (
          <div
            className={`cursor-pointer ${editValue ? 'hidden' : ''}`}
            onClick={() => updateMod(1)}
            onContextMenu={e => {
              e.preventDefault();
              setMod(0);
            }}
          >
            <FaPlus size={10} />
          </div>
        )}
        <div className='flex-1 flex items-center justify-center w-full'>
          <div className='relative w-05 h-full rounded bg-contrast bg-opacity-10 overflow-hidden'>
            <div
              className='absolute left-0 right-0 bg-primary'
              style={{
                bottom: 0,
                height: `${progressPercent}%`,
                transition: '300ms',
              }}
            ></div>
          </div>
        </div>
        <div className='text-center text-xs'>
          {value} / {totalValue}
        </div>
        {canInteract && (
          <div
            className={`cursor-pointer ${editValue ? 'hidden' : ''}`}
            onClick={() => updateMod(-1)}
            onContextMenu={e => {
              e.preventDefault();
              setMod(-totalValue);
            }}
          >
            <FaMinus size={10} />
          </div>
        )}
      </div>
    </div>
  );

  return isVertical ? renderVerticalGauge() : renderHorizontalGauge();
};
